import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Footer_ScreenContext } from "../footer/footer-context";

declare let window: any;

export interface IHizliStokWeb_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IHizliStokWeb_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  B2BGetUserId: any[];
  B2BGetUserId_dummy: any[];
  B2BFastStockCollectionList: any[];
  B2BFastStockCollectionList_dummy: any[];
  B2BHizliStokList: any[];
  B2BHizliStokList_dummy: any[];
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  SetValueOf: any;
  SetValueOf_dummy: any;
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  B2BFastStockDesignList: any[];
  B2BFastStockDesignList_dummy: any[];
  B2BFastStockSizeList: any[];
  B2BFastStockSizeList_dummy: any[];
  B2BNumberInputDegeriAtaMinusSize: any[];
  B2BNumberInputDegeriAtaMinusSize_dummy: any[];
  B2BHizliStokSepeteEkle: any[];
  B2BHizliStokSepeteEkle_dummy: any[];
  Qty1BasketZero: number;
  Qty1BasketZero_dummy: number;
  Notify: boolean;
  Notify_dummy: boolean;
  B2BNumberInputDegeriAtaPlusSize: any[];
  B2BNumberInputDegeriAtaPlusSize_dummy: any[];
  B2BNumberInputDegeriAta: any[];
  B2BNumberInputDegeriAta_dummy: any[];
  isComp839611Visible: "visible" | "hidden";
  isComp676612Visible: "visible" | "hidden";
}

export class HizliStokWeb_ScreenBase extends React.PureComponent<
  IHizliStokWeb_ScreenProps,
  any
> {
  static contextType = Footer_ScreenContext;
  declare context: React.ContextType<typeof Footer_ScreenContext>;
  hizlistokweb_765129_value_kuikaSelectBoxRef: React.RefObject<any>;
  hizlistokweb_179679_value_kuikaSelectBoxRef: React.RefObject<any>;
  hizlistokweb_15954_value_kuikaSelectBoxRef: React.RefObject<any>;
  hizlistokweb_296151_value_kuikaSelectBoxRef: React.RefObject<any>;
  hizlistokweb_844678_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 832282,
          PropertyName: "value",
          Value: "Hızlı Stok Ara",
          TagName: "Label5_value",
        },
        {
          Id: 765129,
          PropertyName: "placeholder",
          Value: "Filtrele",
          TagName: "SelectBox1_placeholder",
        },
        {
          Id: 844678,
          PropertyName: "nodatafoundmessage",
          Value: "Lütfen ürün arayınız!",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 301959,
          PropertyName: "value",
          Value: "Koleksiyon",
          TagName: "Label14_value",
        },
        {
          Id: 179679,
          PropertyName: "placeholder",
          Value: "Koleksiyon Seçiniz...",
          TagName: "SelectBox2_placeholder",
        },
        {
          Id: 4517,
          PropertyName: "value",
          Value: "Desen",
          TagName: "Label15_value",
        },
        {
          Id: 15954,
          PropertyName: "placeholder",
          Value: "Desen Seçiniz...",
          TagName: "SelectBox3_placeholder",
        },
        {
          Id: 390632,
          PropertyName: "value",
          Value: "Ebat",
          TagName: "Label16_value",
        },
        {
          Id: 296151,
          PropertyName: "placeholder",
          Value: "Ebat Seçiniz...",
          TagName: "SelectBox4_placeholder",
        },
        {
          Id: 850836,
          PropertyName: "placeholder",
          Value: "Ne arıyorsunuz?",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 347718,
          PropertyName: "label",
          Value: "Ara",
          TagName: "Button3_label",
        },
        {
          Id: 677504,
          PropertyName: "label",
          Value: "Temizle",
          TagName: "Button2_label",
        },
        {
          Id: 98118,
          PropertyName: "label",
          Value: "Ekle",
          TagName: "Button1_label",
        },
        {
          Id: 473897,
          PropertyName: "value",
          Value: "Ebat",
          TagName: "Label9_value",
        },
        {
          Id: 124078,
          PropertyName: "value",
          Value: "Renk",
          TagName: "Label7_value",
        },
        {
          Id: 807791,
          PropertyName: "value",
          Value: "Stokta",
          TagName: "Label11_value",
        },
        {
          Id: 626096,
          PropertyName: "value",
          Value: "adet kaldı!",
          TagName: "Label13_value",
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 832282,
          PropertyName: "value",
          Value: "Quick Stock Search",
          TagName: "Label5_value",
        },
        {
          Id: 765129,
          PropertyName: "placeholder",
          Value: "Filter",
          TagName: "SelectBox1_placeholder",
        },
        {
          Id: 844678,
          PropertyName: "nodatafoundmessage",
          Value: "Please search for products!",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 301959,
          PropertyName: "value",
          Value: "Collection",
          TagName: "Label14_value",
        },
        {
          Id: 179679,
          PropertyName: "placeholder",
          Value: "Select Collection...",
          TagName: "SelectBox2_placeholder",
        },
        {
          Id: 4517,
          PropertyName: "value",
          Value: "Pattern",
          TagName: "Label15_value",
        },
        {
          Id: 15954,
          PropertyName: "placeholder",
          Value: "Select Pattern...",
          TagName: "SelectBox3_placeholder",
        },
        {
          Id: 390632,
          PropertyName: "value",
          Value: "Size",
          TagName: "Label16_value",
        },
        {
          Id: 296151,
          PropertyName: "placeholder",
          Value: "Select Size...",
          TagName: "SelectBox4_placeholder",
        },
        {
          Id: 850836,
          PropertyName: "placeholder",
          Value: "What are you looking for?",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 347718,
          PropertyName: "label",
          Value: "Search",
          TagName: "Button3_label",
        },
        {
          Id: 677504,
          PropertyName: "label",
          Value: "Clear",
          TagName: "Button2_label",
        },
        {
          Id: 98118,
          PropertyName: "label",
          Value: "Add",
          TagName: "Button1_label",
        },
        {
          Id: 473897,
          PropertyName: "value",
          Value: "Size",
          TagName: "Label9_value",
        },
        {
          Id: 124078,
          PropertyName: "value",
          Value: "Colour",
          TagName: "Label7_value",
        },
        {
          Id: 807791,
          PropertyName: "value",
          Value: "in stock",
          TagName: "Label11_value",
        },
        {
          Id: 626096,
          PropertyName: "value",
          Value: "pieces left!",
          TagName: "Label13_value",
        },
      ],
    },
    {
      Id: "ea0a19cb-fb25-49da-92e9-0d244913e956",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 832282, PropertyName: "value", Value: "Hızlı Stok Ara" },
        { Id: 765129, PropertyName: "placeholder", Value: "Filtrele" },
        { Id: 850836, PropertyName: "placeholder", Value: "Ne arıyorsunuz?" },
        { Id: 301959, PropertyName: "value", Value: "Koleksiyon" },
        {
          Id: 179679,
          PropertyName: "placeholder",
          Value: "Koleksiyon Seçiniz...",
        },
        { Id: 4517, PropertyName: "value", Value: "Desen" },
        { Id: 15954, PropertyName: "placeholder", Value: "Desen Seçiniz..." },
        { Id: 390632, PropertyName: "value", Value: "Ebat" },
        { Id: 296151, PropertyName: "placeholder", Value: "Ebat Seçiniz..." },
        { Id: 347718, PropertyName: "label", Value: "Ara" },
        { Id: 677504, PropertyName: "label", Value: "Temizle" },
        {
          Id: 844678,
          PropertyName: "nodatafoundmessage",
          Value: "Lütfen ürün arayınız!",
        },
        { Id: 856619, PropertyName: "title", Value: "Title" },
        {
          Id: 978827,
          PropertyName: "value",
          Value: "[datafield:koleksiyonadi]",
        },
        { Id: 137974, PropertyName: "value", Value: "[datafield:desenadi]" },
        { Id: 473897, PropertyName: "value", Value: "Ebat" },
        {
          Id: 321390,
          PropertyName: "value",
          Value: "[datafield:sizedescription]",
        },
        { Id: 124078, PropertyName: "value", Value: "Renk" },
        {
          Id: 435405,
          PropertyName: "value",
          Value: "[datafield:colordescription]",
        },
        { Id: 807791, PropertyName: "value", Value: "Stokta" },
        {
          Id: 25272,
          PropertyName: "value",
          Value: "[datafield:inventoryqty1]",
        },
        { Id: 626096, PropertyName: "value", Value: "adet kaldı!" },
        { Id: 98118, PropertyName: "label", Value: "Ekle" },
        { Id: 401619, PropertyName: "title", Value: "Title" },
        { Id: 175138, PropertyName: "value", Value: "[datafield:qty1basket]" },
        { Id: 491973, PropertyName: "placeholder", Value: "15" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.hizlistokweb_765129_value_kuikaSelectBoxRef = React.createRef();
    this.hizlistokweb_850836_value_kuikaTextInputRef = React.createRef();
    this.hizlistokweb_179679_value_kuikaSelectBoxRef = React.createRef();
    this.hizlistokweb_15954_value_kuikaSelectBoxRef = React.createRef();
    this.hizlistokweb_296151_value_kuikaSelectBoxRef = React.createRef();
    this.hizlistokweb_844678_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      B2BGetUserId: [],
      B2BFastStockCollectionList: [],
      B2BHizliStokList: [],
      TriggerEvent: "",
      SetValueOf: "",
      ChangeVisibilityOf: "",
      B2BFastStockDesignList: [],
      B2BFastStockSizeList: [],
      B2BNumberInputDegeriAtaMinusSize: [],
      B2BHizliStokSepeteEkle: [],
      Qty1BasketZero: 0,
      Notify: false,
      B2BNumberInputDegeriAtaPlusSize: [],
      B2BNumberInputDegeriAta: [],
      dataSource_765129: [
        { key: "1", text: "Tümü" },
        { key: "2", text: "Stokta Olanlar" },
      ],
      isComp839611Visible: "hidden",
      isComp676612Visible: "hidden",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "hizlistokweb",
        "footer_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.HizliStokWebPageInit();
    } else if (
      !this.context?.callCallbackFunction ||
      this.context?.isMasterPageInitLoaded
    ) {
      this._prevMasterPageInitLoaded =
        this.context?.isMasterPageInitLoaded ?? false;
      await this.HizliStokWebPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("hizlistokweb", "footer_screen");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BCustomer"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("hizlistokweb", "footer_screen");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.HizliStokWebPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.HizliStokWebPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  HizliStokWebPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      KUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      UserId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HizliStokWeb/HizliStokWebPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BGetUserId = result?.data.b2BGetUserId;
    stateVars.B2BFastStockCollectionList =
      result?.data.b2BFastStockCollectionList;

    formVars.hizlistokweb_179679_options = stateVars.B2BFastStockCollectionList;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HizliStokWebPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HizliStokWebPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      TbUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      SearchText_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      FilterType_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_765129_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      KoleksiyonAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_179679_value",
            "value",
            "B2BFastStockCollectionList",
            "koleksiyonKodu",
            "koleksiyonAdi"
          )
        ),
        "string"
      ),
      DesenAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_15954_value",
            "value",
            "B2BFastStockDesignList",
            "desenKodu",
            "desenAdi"
          )
        ),
        "string"
      ),
      EbatAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_296151_value",
            "value",
            "B2BFastStockSizeList",
            "sizeCode",
            "sizeDescription"
          )
        ),
        "string"
      ),
    };

    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_179679_value",
            "value",
            "B2BFastStockCollectionList",
            "koleksiyonKodu",
            "koleksiyonAdi"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) ||
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_15954_value",
            "value",
            "B2BFastStockDesignList",
            "desenKodu",
            "desenAdi"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) ||
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_296151_value",
            "value",
            "B2BFastStockSizeList",
            "sizeCode",
            "sizeDescription"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "HizliStokWeb/HizliStokWebPageInit1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.B2BHizliStokList = result?.data.b2BHizliStokList;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HizliStokWebPageInit2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HizliStokWebPageInit2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HizliStokWebPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      TbUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      SearchText_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_850836_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      FilterType_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_765129_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      KoleksiyonAdi_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      DesenAdi_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      EbatAdi_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
    };

    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_850836_value",
            "value",
            "",
            "",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "HizliStokWeb/HizliStokWebPageInit2_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.B2BHizliStokList = result?.data.b2BHizliStokList;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HizliStokWebPageInit3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HizliStokWebPageInit3_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HizliStokWebPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    this.context.setMasterPageInitLoaded(false);
    this.context.setMasterPageRecurringLoaded(false);
    this.context.setShouldTriggerPageInit(true);
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HizliStokWebPageInit4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HizliStokWebPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_179679_value",
            "value",
            "B2BFastStockCollectionList",
            "koleksiyonKodu",
            "koleksiyonAdi"
          )
        ),
        true
      ) ||
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_15954_value",
            "value",
            "B2BFastStockDesignList",
            "desenKodu",
            "desenAdi"
          )
        ),
        true
      ) ||
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_296151_value",
            "value",
            "B2BFastStockSizeList",
            "sizeCode",
            "sizeDescription"
          )
        ),
        true
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HizliStokWebPageInit5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HizliStokWebPageInit5_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HizliStokWebPageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_179679_value",
            "value",
            "B2BFastStockCollectionList",
            "koleksiyonKodu",
            "koleksiyonAdi"
          )
        ),
        true
      ) ||
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_15954_value",
            "value",
            "B2BFastStockDesignList",
            "desenKodu",
            "desenAdi"
          )
        ),
        true
      ) ||
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_296151_value",
            "value",
            "B2BFastStockSizeList",
            "sizeCode",
            "sizeDescription"
          )
        ),
        true
      )
    ) {
      stateVars.dataSource_844678 =
        stateVars.B2BHizliStokList ?? this.state.B2BHizliStokList;

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  HizliStokWebComponent_624552_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HizliStokWebComponent_583469_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "hizlistokweb_179679_value",
        "string"
      ),
      "",
      null,
      "KoleksiyonKodu"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "hizlistokweb_15954_value",
        "string"
      ),
      "",
      null,
      "DesenKodu"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "hizlistokweb_296151_value",
        "string"
      ),
      "",
      null,
      "SizeCode"
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HizliStokWebComponent_583469_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HizliStokWebComponent_583469_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      TbUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      SearchText_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_850836_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      FilterType_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_765129_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      KoleksiyonAdi_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      DesenAdi_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      EbatAdi_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HizliStokWeb/HizliStokWebComponent_583469_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BHizliStokList = result?.data.b2BHizliStokList;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HizliStokWebComponent_583469_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HizliStokWebComponent_583469_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp839611Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    stateVars.dataSource_844678 =
      stateVars.B2BHizliStokList ?? this.state.B2BHizliStokList;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HizliStokWebComponent_179679_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "hizlistokweb_15954_value",
        "string"
      ),
      "",
      null,
      "DesenKodu"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "hizlistokweb_296151_value",
        "string"
      ),
      "",
      null,
      "SizeCode"
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HizliStokWebComponent_179679_onChange1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HizliStokWebComponent_179679_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      ProductAttribute02_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_179679_value",
            "value",
            "B2BFastStockCollectionList",
            "koleksiyonKodu",
            "koleksiyonKodu"
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HizliStokWeb/HizliStokWebComponent_179679_onChange1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BFastStockDesignList = result?.data.b2BFastStockDesignList;

    formVars.hizlistokweb_15954_options = stateVars.B2BFastStockDesignList;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HizliStokWebComponent_179679_onChange2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HizliStokWebComponent_179679_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (await this.HizliStokWebComponent_15954_onChange()) return true;

    stateVars.dataSource_15954 =
      stateVars.B2BFastStockDesignList ?? this.state.B2BFastStockDesignList;
    stateVars.dataSource_15954 =
      stateVars.B2BFastStockDesignList ?? this.state.B2BFastStockDesignList;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HizliStokWebComponent_15954_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "hizlistokweb_296151_value",
        "string"
      ),
      "",
      null,
      "SizeCode"
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HizliStokWebComponent_15954_onChange1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HizliStokWebComponent_15954_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      ProductAttribute02_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_179679_value",
            "value",
            "B2BFastStockCollectionList",
            "koleksiyonKodu",
            "koleksiyonKodu"
          )
        ),
        "string"
      ),
      ProductAttribute03_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_15954_value",
            "value",
            "B2BFastStockDesignList",
            "desenKodu",
            "desenKodu"
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HizliStokWeb/HizliStokWebComponent_15954_onChange1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BFastStockSizeList = result?.data.b2BFastStockSizeList;

    formVars.hizlistokweb_296151_options = stateVars.B2BFastStockSizeList;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HizliStokWebComponent_15954_onChange2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HizliStokWebComponent_15954_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_296151 =
      stateVars.B2BFastStockSizeList ?? this.state.B2BFastStockSizeList;
    stateVars.dataSource_296151 =
      stateVars.B2BFastStockSizeList ?? this.state.B2BFastStockSizeList;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HizliStokWebComponent_347718_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "hizlistokweb_850836_value",
        "string"
      ),
      "",
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HizliStokWebComponent_347718_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HizliStokWebComponent_347718_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      TbUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      SearchText_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      FilterType_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_765129_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      KoleksiyonAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_179679_value",
            "value",
            "B2BFastStockCollectionList",
            "koleksiyonKodu",
            "koleksiyonAdi"
          )
        ),
        "string"
      ),
      DesenAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_15954_value",
            "value",
            "B2BFastStockDesignList",
            "desenKodu",
            "desenAdi"
          )
        ),
        "string"
      ),
      EbatAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_296151_value",
            "value",
            "B2BFastStockSizeList",
            "sizeCode",
            "sizeDescription"
          )
        ),
        "string"
      ),
    };

    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_179679_value",
            "value",
            "B2BFastStockCollectionList",
            "koleksiyonKodu",
            "koleksiyonAdi"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) ||
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_15954_value",
            "value",
            "B2BFastStockDesignList",
            "desenKodu",
            "desenAdi"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) ||
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_296151_value",
            "value",
            "B2BFastStockSizeList",
            "sizeCode",
            "sizeDescription"
          )
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "HizliStokWeb/HizliStokWebComponent_347718_onClick1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.B2BHizliStokList = result?.data.b2BHizliStokList;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HizliStokWebComponent_347718_onClick2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HizliStokWebComponent_347718_onClick2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HizliStokWebComponent_347718_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp839611Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HizliStokWebComponent_347718_onClick3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HizliStokWebComponent_347718_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_179679_value",
            "value",
            "B2BFastStockCollectionList",
            "koleksiyonKodu",
            "koleksiyonAdi"
          )
        ),
        true
      ) ||
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_15954_value",
            "value",
            "B2BFastStockDesignList",
            "desenKodu",
            "desenAdi"
          )
        ),
        true
      ) ||
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_296151_value",
            "value",
            "B2BFastStockSizeList",
            "sizeCode",
            "sizeDescription"
          )
        ),
        true
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HizliStokWebComponent_347718_onClick4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HizliStokWebComponent_347718_onClick4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HizliStokWebComponent_347718_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_179679_value",
            "value",
            "B2BFastStockCollectionList",
            "koleksiyonKodu",
            "koleksiyonAdi"
          )
        ),
        true
      ) ||
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_15954_value",
            "value",
            "B2BFastStockDesignList",
            "desenKodu",
            "desenAdi"
          )
        ),
        true
      ) ||
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hizlistokweb_296151_value",
            "value",
            "B2BFastStockSizeList",
            "sizeCode",
            "sizeDescription"
          )
        ),
        true
      )
    ) {
      stateVars.dataSource_844678 =
        stateVars.B2BHizliStokList ?? this.state.B2BHizliStokList;

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  HizliStokWebComponent_677504_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "hizlistokweb_179679_value",
        "string"
      ),
      "",
      null,
      "KoleksiyonKodu"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "hizlistokweb_15954_value",
        "string"
      ),
      "",
      null,
      "DesenKodu"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "hizlistokweb_296151_value",
        "string"
      ),
      "",
      null,
      "SizeCode"
    );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp839611Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HizliStokWebComponent_115234_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ItemId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "hizlistokweb_844678_value", "itemId"),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HizliStokWeb/HizliStokWebComponent_115234_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BNumberInputDegeriAtaMinusSize =
      result?.data.b2BNumberInputDegeriAtaMinusSize;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HizliStokWebComponent_115234_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HizliStokWebComponent_115234_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.HizliStokWebPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HizliStokWebComponent_98118_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerUserID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      ItemId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "hizlistokweb_844678_value", "itemId"),
        "Guid"
      ),
      Qty1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "hizlistokweb_844678_value",
          "qty1Basket"
        ),
        "number"
      ),
      KUserID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      ProductAttribute03_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "hizlistokweb_844678_value",
          "productAttribute03"
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HizliStokWeb/HizliStokWebComponent_98118_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BHizliStokSepeteEkle = result?.data.b2BHizliStokSepeteEkle;
    stateVars.Qty1BasketZero = result?.data.qty1BasketZero;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HizliStokWebComponent_98118_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HizliStokWebComponent_98118_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.B2BHizliStokSepeteEkle !== undefined
          ? stateVars.B2BHizliStokSepeteEkle?.length > 0
            ? stateVars.B2BHizliStokSepeteEkle[0].message
            : null
          : this.state.B2BHizliStokSepeteEkle?.length > 0
          ? this.state.B2BHizliStokSepeteEkle[0].message
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    await this.HizliStokWebPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HizliStokWebComponent_271469_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ItemId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "hizlistokweb_844678_value", "itemId"),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HizliStokWeb/HizliStokWebComponent_271469_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BNumberInputDegeriAtaPlusSize =
      result?.data.b2BNumberInputDegeriAtaPlusSize;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HizliStokWebComponent_271469_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HizliStokWebComponent_271469_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.HizliStokWebPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HizliStokWebComponent_491973_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      QtyInputValue_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "Table_844678_qty1Basket",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ItemId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "hizlistokweb_844678_value", "itemId"),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HizliStokWeb/HizliStokWebComponent_491973_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BNumberInputDegeriAta = result?.data.b2BNumberInputDegeriAta;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HizliStokWebComponent_491973_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HizliStokWebComponent_491973_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.B2BNumberInputDegeriAta !== undefined
          ? stateVars.B2BNumberInputDegeriAta?.length > 0
            ? stateVars.B2BNumberInputDegeriAta[0].message
            : null
          : this.state.B2BNumberInputDegeriAta?.length > 0
          ? this.state.B2BNumberInputDegeriAta[0].message
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    await this.HizliStokWebPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.HizliStokWebPageInit();
    }
  }
}
